import { render, staticRenderFns } from "./TeamDataInit.vue?vue&type=template&id=8ed59b94&scoped=true"
import script from "./TeamDataInit.vue?vue&type=script&lang=js"
export * from "./TeamDataInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed59b94",
  null
  
)

export default component.exports